import { updatesData } from '@/mocks/homepage';

const typeStyles: Record<string, string> = {
  update: 'bg-primary-100 text-primary-700',
  announce: 'bg-accent-100 text-accent-800',
  new: 'bg-secondary-100 text-secondary-800',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            最近更新
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            实时追踪漫画更新动态，精彩内容不再错过
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {updatesData.map((item, index) => (
            <div key={item.id} className="relative flex gap-4 pb-6 last:pb-0">
              {index < updatesData.length - 1 && (
                <div className="absolute left-[15px] top-10 bottom-0 w-px bg-background-300/60"></div>
              )}
              <div className="relative z-10 w-[30px] h-[30px] rounded-full bg-background-50 border-2 border-primary-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                <div className="w-2 h-2 rounded-full bg-primary-500"></div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {item.time}
                  </span>
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium whitespace-nowrap ${typeStyles[item.type] || 'bg-background-200 text-foreground-600'}`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-medium text-sm text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}